import { BaseRequests } from "../../../config/BaseRequests";
import { profileApiEndpoints } from "../api/profile.api";
import { ProfileDto, UpdateProfileDto } from "../dto/profile.dto";

export class ProfileService {
  static getMe = (): Promise<ProfileDto> =>
    BaseRequests.get(profileApiEndpoints.getMe);

  static updateMe = (data: UpdateProfileDto): Promise<ProfileDto> =>
    BaseRequests.patch(profileApiEndpoints.updateMe, data);
}
